import Constants from '../actions/types';
import _ from 'lodash';

const initialState = {
  performanceMetrics: [],
  cpuUsage: {
    series: [
      {
        name: 'Process',
        data: []
      },
      {
        name: 'System',
        data: []
      }
    ]
  },
  memoryUsage: {
    series: [
      {
        name: 'Used',
        data: []
      },
      {
        name: 'Allocated',
        data: []
      },
      {
        name: 'Maximum',
        data: []
      }
    ]
  },
  loading: false,
  message: null,
  severity: null
};

const updateCpuUsage = (state, data) => {
  const newSamples = _.cloneDeep(state.cpuUsage);
  const processLoad = data['processCpuLoad'];
  const systemLoad = data['systemCpuLoad'];
  newSamples.series[0].data.push([data.timestamp, processLoad]);
  newSamples.series[1].data.push([data.timestamp, systemLoad]);
  return newSamples;
};

const updateMemoryUsage = (state, data) => {
  const newSamples = _.cloneDeep(state.memoryUsage);
  const heapUsed = data['heap.used'] / (1024 * 1024 * 1024);
  const heapMaximum = data['heap.maximum'] / (1024 * 1024 * 1024);
  const heapTotal = data['heap.total'] / (1024 * 1024 * 1024);
  newSamples.series[0].data.push([data.timestamp, heapUsed]);
  newSamples.series[1].data.push([data.timestamp, heapTotal]);
  newSamples.series[2].data.push([data.timestamp, heapMaximum]);
  return newSamples;
};

const performanceMetricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.PERFORMANCEMETRICS_GET_SUCCESS: {
      const cpuUsage = updateCpuUsage(state, action.payload);
      const memoryUsage = updateMemoryUsage(state, action.payload);
      const newState = {
        ...state,
        performanceMetrics: action.payload,
        cpuUsage: cpuUsage,
        memoryUsage: memoryUsage,
        loading: false
      };

      return newState;
    }

    case Constants.PERFORMANCEMETRICS_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.PERFORMANCEMETRICS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default performanceMetricsReducer;
